export default __webpack_public_path__ + "static/media/13.7394d1be.jpg";